import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Trophy, Smartphone, MessageCircle, ShoppingBag } from "lucide-react";

const eur = (v) => `€ ${Number(v || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const when = (iso) => new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Rome" });

// Classifica offerte lampo concluse: incasso generato e clienti portati in cassa
export default function FlashRankingCard() {
  const [months, setMonths] = useState(3);
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/proximity/flash/ranking", { params: { months } }).then((r) => setD(r.data)).catch(() => setD(null)); }, [months]);
  if (!d) return null;
  const t = d.totals;
  const medal = (i) => (i === 1 ? "text-amber-300" : i === 2 ? "text-zinc-300" : i === 3 ? "text-orange-400" : "text-zinc-500");
  return (
    <div className="card-elev p-4 space-y-3" data-testid="flash-ranking-card">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="text-[10px] uppercase tracking-widest text-zinc-500 flex items-center gap-1.5"><Trophy className="h-3.5 w-3.5 text-amber-300" /> Classifica offerte lampo</div>
        <select value={months} onChange={(e) => setMonths(Number(e.target.value))} className="bg-zinc-950 border border-zinc-800 rounded-md h-8 px-2 text-xs" data-testid="flash-ranking-months">
          {[[1, "Ultimo mese"], [3, "Ultimi 3 mesi"], [6, "Ultimi 6 mesi"], [12, "Ultimo anno"]].map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 text-xs" data-testid="flash-ranking-totals">
        {[["Offerte", t.offers], ["Incasso generato", eur(t.eur)], ["Clienti in cassa", t.customers], ["Scontrini", t.purchases]].map(([l, v]) => (
          <div key={l} className="rounded-lg bg-zinc-950 border border-zinc-800 px-3 py-2"><div className="text-[10px] uppercase tracking-widest text-zinc-500">{l}</div><div className="font-heading text-lg font-bold">{v}</div></div>
        ))}
      </div>
      {d.items.length === 0 ? <div className="text-xs text-zinc-500" data-testid="flash-ranking-empty">Nessuna offerta lampo conclusa nel periodo.</div> : (
        <ul className="divide-y divide-zinc-800/70" data-testid="flash-ranking-list">
          {d.items.slice(0, 15).map((f) => {
            const s = f.stats, share = t.eur > 0 ? Math.round((s.eur / t.eur) * 100) : 0;
            return (
              <li key={f.id} className="py-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs" data-testid={`flash-rank-${f.id}`}>
                <span className={`font-heading text-lg font-extrabold w-7 ${medal(f.rank)}`} data-testid={`flash-rank-pos-${f.id}`}>#{f.rank}</span>
                <div className="flex-1 min-w-[180px]">
                  <div className="font-semibold">⚡ {f.title} <span className="text-zinc-500 font-normal">· {f.branch_name}{f.segment_name ? ` · ${f.segment_name}` : ""} · {when(f.starts_at)}</span></div>
                  <div className="mt-1 h-1.5 rounded-full bg-zinc-800 overflow-hidden"><div className="h-full bg-amber-400" style={{ width: `${share}%` }} /></div>
                </div>
                <span className="text-emerald-300 font-semibold" data-testid={`flash-rank-eur-${f.id}`}>{eur(s.eur)}</span>
                <span className="text-zinc-300"><ShoppingBag className="inline h-3 w-3 mr-0.5" /> <b data-testid={`flash-rank-customers-${f.id}`}>{s.customers}</b> clienti</span>
                <span className="text-zinc-500"><Smartphone className="inline h-3 w-3" /> {s.wallet_pushed} · <MessageCircle className="inline h-3 w-3" /> {f.wa_sent ?? 0} · web app {s.reached}</span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
